import styles from './styles.module.css';

import { features } from 'src/constants/data/Features';

const Features = () => {
    return (
        <section className={`${styles.features} container`}>
            <div className={`${styles.title} mb-5`}>
                <h4>ما يميزنا عن غيرنا</h4>
                <div className={styles.underline}></div>
            </div>

            <div className="row">
                {features.map((item) => (
                    <div
                        key={item.id}
                        data-aos="fade-up"
                        data-aos-delay="400"
                        data-aos-duration="600"
                        className="col-12 col-lg-4 col-md-6 mb-5"
                    >
                        <div className={styles.fCard}>
                            <div className={styles.icon}>
                                <item.icon size={70} />
                            </div>

                            <div className={styles.cardTitle}>
                                {item.title}
                            </div>

                            <div className={styles.text}>
                                {item.text}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Features;
